import {InferSubjects, MongoAbility, Subject} from "@casl/ability";
import React from "react";
import {User} from "../commons/models/user";
import {ManageFootballPlayer} from "../commons/models/football/admin/manage-football-player";
import {ManageFootballCompetition} from "../commons/models/football/admin/manage-football-competition";
import {ManageFootballTeam} from "../commons/models/football/admin/manage-football-team";
import {ManageFootballReferee} from "../commons/models/football/admin/manage-football-referee";
import {Stadium} from "../commons/models/stadium";
import {FootballMatchDetail} from "../commons/models/football/football-match-detail";
import { FootballOrganizer } from "../commons/models/football/football-organizer";

export type Actions =   'manage'|'read'|'create'| 'update'| 'delete'|'invite'|'assign'|'status';

export type Subjects =
    | InferSubjects<
    | typeof User
    | typeof ManageFootballPlayer
    | typeof ManageFootballCompetition
    | typeof ManageFootballTeam
    | typeof ManageFootballReferee
    | typeof FootballMatchDetail
    | typeof Stadium
    | typeof FootballOrganizer
>|string|'all';

export type AppAbility = MongoAbility<[Actions, Subjects]>;

export const AbilityContext = React.createContext<AppAbility>({} as AppAbility);